module.exports = require('./helpers/bundle-url').getBundleURL('hRXdN') + "gosat-based-ch4budget-yeargrid-v1.thumbnails.priori.wetlands.7dc9ba6f.png";